import { render, staticRenderFns } from "./AddSpecification.vue?vue&type=template&id=79d1e47f&scoped=true"
import script from "./AddSpecification.vue?vue&type=script&lang=js"
export * from "./AddSpecification.vue?vue&type=script&lang=js"
import style0 from "./AddSpecification.vue?vue&type=style&index=0&id=79d1e47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1e47f",
  null
  
)

export default component.exports